<template>
    <div class="loading-dots">
        <div class="loading-dots--dot"></div>
        <div class="loading-dots--dot"></div>
        <div class="loading-dots--dot"></div>
    </div>
</template>

<script setuo>
</script>

<style scoped lang="scss">
@keyframes dot-keyframes {
    0% {
        opacity: .4;
        transform: scale(1, 1);
    }

    50% {
        opacity: 1;
        transform: scale(1.2, 1.2);
    }

    100% {
        opacity: .4;
        transform: scale(1, 1);
    }
}

.loading-dots {
    text-align: center;
    width: 100%;

    &--dot {
        animation: dot-keyframes 1.5s infinite ease-in-out;
        background-color: var(--foreground-accent-default, #f01);
        border-radius: 35px;
        display: inline-block;
        height: 35px;
        width: 35px;
        margin-left: 10px;

        &:nth-child(2) {
            animation-delay: .5s;
        }

        &:nth-child(3) {
            animation-delay: 1s;
        }
    }
}
</style>